import { Dispatch } from 'redux';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleModal } from '../../../../ModalTest/actions';
import Button from '../../../../Button';
import Modal from '../../../../ModalTest';

interface DeleteAresContactsModalProps extends ReduxComponentInterface {
  items: any;
}

class DeleteAresContactsModal extends React.PureComponent<DeleteAresContactsModalProps> {
  onModalClose = (event: MouseEvent) => {
    const { actions } = this.props;
    event && event.preventDefault();
    actions.toggleModal(false, 'deleteAresContactsModal');
  };

  onSubmit = async (event: MouseEvent) => {
    event.preventDefault();
    const {
      actions,
      items: { callback },
    } = this.props;

    await callback();
    actions.toggleModal(false, 'deleteAresContactsModal');
  };

  render() {
    return (
      <Modal
        name={'deleteAresContactsModal'}
        title={window.Alfresco.messages.global[`edocat.document-details.ares-delete-contact-label`]}
      >
        <div className="modal-body">{window.Alfresco.messages.global['edocat.document-details.ares-delete-contact']}</div>
        <div className="modal-actions">
          <Button onClick={this.onSubmit} label={window.Alfresco.messages.global['button.ok']} primary />
          <Button onClick={this.onModalClose} label={window.Alfresco.messages.global['button.close']} />
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state: any) => ({
  items: state.modal?.deleteAresContactsModal?.items,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators(
    { toggleModal},
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAresContactsModal);